import { render, staticRenderFns } from "./Reject.vue?vue&type=template&id=861069b6&scoped=true&"
import script from "./Reject.vue?vue&type=script&lang=js&"
export * from "./Reject.vue?vue&type=script&lang=js&"
import style0 from "./Reject.vue?vue&type=style&index=0&id=861069b6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "861069b6",
  null
  
)

export default component.exports